export default ()=>{
    return  {
        mounted: (el,binding) => {
          const tooltip = document.createElement('div');
          
          if(binding.modifiers.info) {
            tooltip.className = 'directive-tooltip-info';
          }else{
            tooltip.className = 'directive-tooltip';
          }

          el.style.position = 'relative';

          tooltip.textContent = binding.value;

          el.appendChild(tooltip);
         
          el.addEventListener('mouseover', () => {
            const rect = el.getBoundingClientRect()
            const x = rect.left + 20
            const y = rect.top + 40
            tooltip.style.display = 'block';
            // console.log(`Mouse X: ${x}, Mouse Y: ${y}`) 
            tooltip.style.left = `${x}px`;
            tooltip.style.top = `${y}px`;
          });
          el.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          })
          // console.log(tooltip.offsetBottom);
      }
    }
}

